export const collapseCategory = (
  target: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  categoryNode: CategoryNode,
  isMobile = false,
  className = ''
) => {
  const targetClass = isMobile ? 'drawer__mobile' : 'section-box';
  const targetClassCamelCase = isMobile ? 'mobileSidebar' : 'sectionBox';

  if (categoryNode[`${targetClassCamelCase}ChildrenInnerFor${target}`]) {
    const targetInnerHeight =
      categoryNode[`${targetClassCamelCase}ChildrenInnerFor${target}`]
        .clientHeight;
    const targetHeight =
      categoryNode[`${targetClassCamelCase}ChildrenFor${target}`].style.height;
    const collapseElement =
      categoryNode[`${targetClassCamelCase}CollapseFor${target}`].className;

    if (collapseElement.includes('--collapseIn')) {
      categoryNode[`${targetClassCamelCase}CollapseFor${target}`].className =
        `${className} ${targetClass}__link-box`;
    } else {
      categoryNode[`${targetClassCamelCase}CollapseFor${target}`].className +=
        `${className} ${targetClass}__link-box ${targetClass}__link-box--collapseIn`;
    }

    let timeoutTime = 50;
    let height = '0px';
    if (targetHeight === '0px') {
      timeoutTime = 450;
      height = 'auto';
    }

    categoryNode[`${targetClassCamelCase}ChildrenFor${target}`].style.height =
      `${targetInnerHeight}px`;
    setTimeout(() => {
      categoryNode[`${targetClassCamelCase}ChildrenFor${target}`].style.height =
        height;
    }, timeoutTime);
  }
};
